export default class AutoSave {
  constructor(el) {
    this.el = el;
    this.saveButton = this.el.querySelector('.do-button');
    // Methods are l (local - simple-data-storage) or r (remote - ajax callbak)
    // for the first disabled
    if (this.storageAvailable('localStorage')) {
      this.storeMethod = 'r';
    } else {
      this.storeMethod = 'r';
    }
    this.fields = this.el
      .getAttribute('data-as-fields')
      .replace(/\s/g, '')
      .split(',');
    this.urlHash = window.md5(
      window.location.href.substr(
        0,
        window.location.href.length - window.location.hash.length
      )
    );
    this.saveButton.addEventListener('click', () => {
      if (this.storeMethod === 'r') {
        $.ajax({
          url: '/ajax.php',
          method: 'POST',
          type: 'json',
          data: {
            mode: 'as_del',
            urlhash: this.urlHash
          }
        });
      } else {
        localStorage.removeItem(this.urlHash);
      }
    });
    // localStorage.removeItem(this.urlHash);

    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    this.compareData();
    this.startAutoSave(20000);
  }

  compareData() {
    // console.log('compareData');
    // console.log(Date.now());
    if (this.storeMethod === 'r') {
      this.dbData = this.readDataRemote();
    } else {
      this.dbData = this.readDataLocal();
    }
    if (
      this.dbData === null ||
      this.dbData === undefined ||
      Object.entries(this.dbData).toString().length === 0
    ) {
      this.dbData = { counter: 0 };
    } else {
      this.dbData = JSON.parse(this.dbData);
    }
    this.currentData = this.readCurrent();
    // console.log('this.dbData', this.dbData);
    // console.log('this.currentData', this.currentData);
    if (this.currentData.counter === 0 && this.dbData.counter !== 0) {
      // console.log('this.currentData.counter is: ');
      // console.log(this.currentData.counter);
      this.readCurrent(1);
    } else {
      this.saveData(JSON.stringify(this.currentData));
    }
    //  Object.entries(this.currentData).toString() !==
    //  Object.entries(this.dbData).toString()
  }

  readCurrent(n) {
    n = n || 0; // eslint-disable-line no-param-reassign
    const result = { astime: Date.now(), counter: 0 };
    this.fields.forEach(field => {
      const vari = field.split('=');
      const type = vari[0];
      const name = vari[1];
      let inputField = '';
      let selector = '';
      switch (type) {
        case 'i':
          selector = `input[name="${name}"]`;
          inputField = this.el.querySelector(selector);
          if (n) {
            inputField.value = this.dbData[name];
          }
          result[name] = inputField.value;
          result.counter += result[name].length;
          break;
        case 'tc':
          if (n) {
            window.CKEDITOR.instances.text.setData(this.dbData[name]);
          }
          result[name] = window.CKEDITOR.instances.text.getData();
          result.counter += result[name].length;
          break;
        case 't':
          selector = `textarea[name="${name}"]`;
          // console.log(selector);
          inputField = this.el.querySelector(selector);
          if (n) {
            inputField.value = this.dbData[name];
          }
          result[name] = inputField.value;
          result.counter += result[name].length;
          break;
        case 's':
          selector = `select[name="${name}"]`;
          inputField = this.el.querySelector(selector);
          if (n) {
            inputField.value = this.dbData[name];
          }
          result[name] = inputField.value;
          // result.counter += result[name].length;
          break;
        default: // Do nothing
      }
    });
    return result;
  }

  saveData(content) {
    // console.log('asegura local');
    // console.log(content);
    if (this.storeMethod === 'r') {
      $.ajax({
        url: '/ajax.php',
        method: 'POST',
        type: 'json',
        data: {
          mode: 'as_set',
          urlhash: this.urlHash,
          content
        }
      });
    } else {
      localStorage.setItem(this.urlHash, content);
    }
  }

  readDataLocal() {
    return localStorage.getItem(this.urlHash);
  }

  readDataRemote() {
    let output;
    $.ajax({
      url: '/ajax.php',
      method: 'POST',
      type: 'json',
      async: false,
      data: {
        mode: 'as_get',
        urlhash: this.urlHash
      },
      success: respons => {
        output = respons.savedAS;
      }
    });
    return output;
  }

  storageAvailable(type) {
    let storage;
    let response;
    try {
      storage = window[type];
      const x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      response = true;
    } catch (e) {
      storage =
        e instanceof DOMException &&
        (e.code === 22 ||
          e.code === 1014 ||
          e.name === 'QuotaExceededError' ||
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        storage &&
        storage.length !== 0;
    }
    return response;
  }

  // Start interval action - look for changes and save them.
  startAutoSave(duration) {
    setInterval(() => {
      this.compareData();
    }, duration);
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/autosave.js